import { routes } from "../config/routes";

export const getRouteByCategoryId = (categoryId: number): string => {
  const route = routes.find((r) => r.categoryId === categoryId);

  return route?.path || "/services";
};
